import * as XLSX from "xlsx";
import dayjs from "dayjs";

// Gera um .xlsx com uma aba a partir de uma lista de objetos (cada chave vira uma coluna)
export function exportToExcel(rows, sheetName, fileName) {
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(rows), sheetName);
    XLSX.writeFile(workbook, `${fileName}_${dayjs().format("YYYYMMDD_HHmmss")}.xlsx`);
}
